import { keyLabel } from "../../lib/hotkeys";

/** Key hint. On buttons it only shows with a mouse, phones and tablets have no keyboard. */
export function Kbd({ keys, always = false }: { keys: string[]; always?: boolean }) {
  if (keys.length === 0) return null;
  return (
    <span aria-hidden="true" className={`items-center gap-1 ${always ? "inline-flex" : "hidden pointer-fine:inline-flex"}`}>
      {keys.map((k) => (
        <kbd key={k} className="rounded border border-current/30 px-1.5 py-px font-sans text-xs font-medium leading-4 opacity-75">
          {keyLabel(k)}
        </kbd>
      ))}
    </span>
  );
}
